import { render, staticRenderFns } from "./DocumentKindDropDownSelector.vue?vue&type=template&id=851f37d2&scoped=true&"
import script from "./DocumentKindDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentKindDropDownSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentKindDropDownSelector.vue?vue&type=style&index=0&id=851f37d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f37d2",
  null
  
)

export default component.exports